import { apiRequest } from './apiClient';
import type { RawWorkflowDto, WorkflowDto } from '../model/workflow';
import { denormalizeWorkflow, normalizeWorkflow } from '../model/workflow';

export const getWorkflow = async (workflowId: string): Promise<WorkflowDto> => {
  const raw = await apiRequest<RawWorkflowDto>(`/workflows/${encodeURIComponent(workflowId)}`);
  return normalizeWorkflow(raw);
};

export interface SaveWorkflowArgs {
  id?: string;
  workflow: WorkflowDto;
}

export const saveWorkflow = async ({ id, workflow }: SaveWorkflowArgs): Promise<WorkflowDto> => {
  const raw = denormalizeWorkflow(workflow);

  if (id) {
    const updated = await apiRequest<RawWorkflowDto>(`/workflows/${encodeURIComponent(id)}`, {
      method: 'PUT',
      body: JSON.stringify(raw),
    });
    return normalizeWorkflow(updated);
  }

  const created = await apiRequest<RawWorkflowDto>('/workflows', {
    method: 'POST',
    body: JSON.stringify(raw),
  });

  return normalizeWorkflow(created);
};

export interface CreateWorkflowResult {
  workflow: WorkflowDto;
  workflowId: string;
}

export const createWorkflow = async (workflow: WorkflowDto): Promise<CreateWorkflowResult> => {
  const raw = denormalizeWorkflow(workflow);
  const created = await apiRequest<RawWorkflowDto>('/workflows', {
    method: 'POST',
    body: JSON.stringify(raw),
  });
  return {
    workflow: normalizeWorkflow(created),
    workflowId: created.workflowId ?? '',
  };
};
